export default __webpack_public_path__ + "static/media/best-404-pages.e9d217d1.png";